module.exports = __webpack_public_path__ + "img/ttl_yonimo@2x.44361dd1.png";